import routerOptions0 from "/home/gitlab-runner/builds/DYLxiz_xJ/0/gemeente-vught/website-speeldoos-nuxt/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/home/gitlab-runner/builds/DYLxiz_xJ/0/gemeente-vught/website-speeldoos-nuxt/app/router.options.ts";
const configRouterOptions = {
  strict: true,
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions1.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}